var _style, _path, _defs, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNoAppointment = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 454.7 429.2",
    style: {
      enableBackground: "new 0 0 454.7 429.2"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#5D9BFD;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#146EFF;}\n\t.st3{fill:#FD3E48;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M145.4,145.1h163.9c6.9,0,12.6,5.6,12.6,12.6c0,0,0,0,0,0v101.7c0,21.7-17.6,39.2-39.2,39.2c0,0,0,0,0,0 H145.4c-6.9,0-12.6-5.6-12.6-12.6l0,0V157.6C132.8,150.7,138.4,145.1,145.4,145.1z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M145.4,145.1h163.9c6.9,0,12.6,5.6,12.6,12.6c0,0,0,0,0,0v101.7c0,21.7-17.6,39.2-39.2,39.2c0,0,0,0,0,0 H145.4c-6.9,0-12.6-5.6-12.6-12.6l0,0V157.6C132.8,150.7,138.4,145.1,145.4,145.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M170.7,232.1h22c1.7,0,3.1,1.4,3.1,3.1v22c0,1.7-1.4,3.1-3.1,3.1h-22c-1.7,0-3.1-1.4-3.1-3.1v-22 C167.6,233.5,169,232.1,170.7,232.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M216.4,232.1h22c1.7,0,3.1,1.4,3.1,3.1v22c0,1.7-1.4,3.1-3.1,3.1h-22c-1.7,0-3.1-1.4-3.1-3.1v-22 C213.2,233.5,214.6,232.1,216.4,232.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M262,232.1h22c1.7,0,3.1,1.4,3.1,3.1v22c0,1.7-1.4,3.1-3.1,3.1h-22c-1.7,0-3.1-1.4-3.1-3.1v-22 C258.9,233.5,260.3,232.1,262,232.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M247.7,130.6L247.7,130.6c4,0,7.2,3.2,7.2,7.2v20.1c0,4-3.2,7.2-7.2,7.2h0c-4,0-7.2-3.2-7.2-7.2v-20.1 C240.4,133.8,243.7,130.6,247.7,130.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M288.3,130.6L288.3,130.6c4,0,7.2,3.2,7.2,7.2v20.1c0,4-3.2,7.2-7.2,7.2h0c-4,0-7.2-3.2-7.2-7.2v-20.1 C281.1,133.8,284.3,130.6,288.3,130.6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M166.3,130.6L166.3,130.6c4,0,7.2,3.2,7.2,7.2v20.1c0,4-3.2,7.2-7.2,7.2h0c-4,0-7.2-3.2-7.2-7.2v-20.1 C159.1,133.8,162.3,130.6,166.3,130.6z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M207,130.6L207,130.6c4,0,7.2,3.2,7.2,7.2v20.1c0,4-3.2,7.2-7.2,7.2h0c-4,0-7.2-3.2-7.2-7.2v-20.1 C199.8,133.8,203,130.6,207,130.6z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M170.7,183.1h22c1.7,0,3.1,1.4,3.1,3.1v22c0,1.7-1.4,3.1-3.1,3.1h-22c-1.7,0-3.1-1.4-3.1-3.1v-22 C167.6,184.5,169,183.1,170.7,183.1z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M216.4,183.1h22c1.7,0,3.1,1.4,3.1,3.1v22c0,1.7-1.4,3.1-3.1,3.1h-22c-1.7,0-3.1-1.4-3.1-3.1v-22 C213.2,184.5,214.6,183.1,216.4,183.1z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M262,183.1h22c1.7,0,3.1,1.4,3.1,3.1v22c0,1.7-1.4,3.1-3.1,3.1h-22c-1.7,0-3.1-1.4-3.1-3.1v-22 C258.9,184.5,260.3,183.1,262,183.1z"
  })))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M321.8,244.6L321.8,244.6c0,10.4,0,17.5-18.2,17.5c-4.5,0-8.3,4.9-8.3,9.4c0.3,20.5-5.8,25.6-7.9,26.8 c19.4-2.4,34.3-18.9,34.3-38.9V244.6z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M176,202.4l3.8-5.2l-3.8-5.2h2.9l2.6,3.7l2.6-3.7h2.9l-3.8,5.2l3.8,5.2h-2.9l-2.6-3.7l-2.6,3.7H176z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M221.8,202.4l3.8-5.2l-3.8-5.2h2.9l2.6,3.7l2.6-3.7h2.9l-3.8,5.2l3.8,5.2H230l-2.6-3.7l-2.6,3.7H221.8z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M267.6,202.4l3.8-5.2l-3.8-5.2h2.9l2.6,3.7l2.6-3.7h2.9l-3.8,5.2l3.8,5.2h-2.9l-2.6-3.7l-2.6,3.7H267.6z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M176,251.1l3.8-5.2l-3.8-5.2h2.9l2.6,3.7l2.6-3.7h2.9l-3.8,5.2l3.8,5.2h-2.9l-2.6-3.7l-2.6,3.7H176z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M221.8,251.1l3.8-5.2l-3.8-5.2h2.9l2.6,3.7l2.6-3.7h2.9l-3.8,5.2l3.8,5.2H230l-2.6-3.7l-2.6,3.7H221.8z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M267.6,251.1l3.8-5.2l-3.8-5.2h2.9l2.6,3.7l2.6-3.7h2.9l-3.8,5.2l3.8,5.2h-2.9l-2.6-3.7l-2.6,3.7H267.6z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoAppointment);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/no-appointment.79386d8c84e1d27dff6e5c6b76bcb635.svg";